<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
    Author: Martin vicencio
========================================================================================== -->


<template>
    <div id="invoice-page">
        <vx-card>

            <!-- INVOICE METADATA -->
            <div class="vx-row leading-loose p-base">
                <div class="vx-col w-full md:w-1/2 mt-base">
                   <!-- <img src="../../assets/images/logo/logo.png" alt="vuesax-logo"> -->
                   <a href="https://upbicentenario.edu.mx/" target="_blank"><b>Pagina Oficial</b></a><br>
                    <a href="https://upbicentenario.edu.mx/tu-universidad-en-linea/" target="_blank"><b>Procedimientos para tramites y servicios de la UPB</b></a>
                </div>
                <div class="vx-col w-full md:w-1/2 text-right">
                    <h1>Mis Datos</h1>
                    <div class="invoice__invoice-detail mt-6">
                        <h3>Bienvenido(a)</h3>                        
                         <h6 class="mt-4"> 
                                <p style="clear:right;">Puesto: {{admin_detalle['puesto']}}
                          <br>Numero Empleado: {{admin_detalle['num_empleado']}}
                         <br>Nombre: {{admin_detalle['nombres']}} {{admin_detalle['apaterno']}} {{admin_detalle['amaterno']}}
                         <br>Correo: {{admin_detalle['correo']}}</p>
                             <!-- Numero Empleado: {{admin_detalle['num_empleado']}}
                              <br>  
                                        {{admin_detalle['nombres']}} {{admin_detalle['apaterno']}} {{admin_detalle['amaterno']}}
                              <br>
                                        {{admin_detalle['correo']}} -->
                          </h6>
                         <br>
                         
                    </div>
                </div>
                <div class="vx-col w-full md:w-1/2 mt-12">
                    <!--  <h5>Dirección</h5>
                      <div class="invoice__recipient-info my-4">
                          <p>{{alumno_detalle[0].dom_calle}}</p>
                          <p>{{alumno_detalle[0].dom_numero_ext}}</p>
                          <p>{{alumno_detalle[0].dom_numero_int}}</p>
                          <p>{{alumno_detalle[0].dom_colonia}}</p>
                          <p>{{alumno_detalle[0].dom_cp}}</p>

                    </div> -->
                </div>

            </div>

            <!-- INVOICE CONTENT -->


            <!-- INVOICE FOOTER -->
            <div class="invoice__footer text-right p-base">
              <!--  <p class="mb-4">Para cambiar la información contactar a control escolar</p>
                <p>
                    <span class="mb4">Correo: <span class="font-semibold">controlescolar@upbicentenario.edu.mx</span></span>

                </p>
-->
            </div>
        </vx-card>
    </div>
</template>

<script>

export default{
    data() {
        return {
            id: localStorage.getItem('id'),
            // matricula: localStorage.getItem('matricula'),
            admin_detalle: []
        }
    },
    computed: {

    },
    created() {
        this.getAdmin();


    },
    methods: {
        getAdmin() {
            this.$http.get("catalogos/get_admin/" + this.id).then(
                response => {
                    // console.log(response.data)
                    this.admin_detalle = response.data.administrativo;
                 //   console.log(this);

                },
                error => {
                    this.StepError(error);
                }
            );
        },
    },

    components: {}
}
</script>
